import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link, useNavigate } from "react-router-dom";
import { AiFillLeftCircle } from "react-icons/ai";
import { AiFillRightCircle } from "react-icons/ai";
import "./Arowbutton.css";
import { useEffect } from "react";
import axios from "axios";
import baseurl from "./Baseurl";
import { useState } from "react";
import secureLocalStorage from "react-secure-storage";
import { ToastContainer, toast } from "react-toastify";
import { BsFillSuitHeartFill } from "react-icons/bs";

function Featuredproducts() {
  let navigate = useNavigate();
  const [slideIndex, setSlideIndex] = useState(0);
  let [images, setimages] = useState([]);

  const plusSlides = (n) => {
    const newIndex = (slideIndex + n + images.length) % images.length;
    setSlideIndex(newIndex);
  };

  const currentSlide = (n) => {
    setSlideIndex(n);
  };

  const CustomPrevArrow = (props) => (
    <button
      className="custom-prev-arrow"
      style={{ right: "60px", top: "-50px", padding: "5px", zIndex: "0" }}
      onClick={props.onClick}
    >
      <i
        className="las la-angle-left"
        style={{
          color: "black",
          border: "1px solid",
          padding: "5px",
          borderRadius: "20px",
          zIndex: "0",
        }}
      />
    </button>
  );

  const CustomNextArrow = (props) => (
    <button
      className="custom-next-arrow"
      style={{ right: "20px", top: "-50px", padding: "5px", zIndex: "0" }}
      onClick={props.onClick}
    >
      <i
        className="las la-angle-right"
        style={{
          color: "black",
          border: "1px solid",
          padding: "5px",
          borderRadius: "20px",
          zIndex: "0",
        }}
      />
    </button>
  );

  const settings = {
    autoplay: false,
    infinite: true,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 1,
    prevArrow: <CustomPrevArrow />,
    nextArrow: <CustomNextArrow />,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  //useState
  let [featured_product_list, setfeatured_product_list] = useState([]);
  let [cardstatus, setcardstatus] = useState(true);
  let token = secureLocalStorage.getItem("n_token");
  let _id = secureLocalStorage.getItem("n_id");
  let cart_list_id = secureLocalStorage.getItem("n_cartlist_id");
  let [showmodel, setshowmodel] = useState([]);
  let [counter, setcounter] = useState(1);
  let [indexvalue, setindex_vlaue] = useState(0);

  useEffect(() => {
    const fetchFeaturedProducts = async () => {
      try {
        const data = { user_id: _id };
        const res = await axios.post(
          `${process.env.REACT_APP_API}website/featured_product_list`,
          data
        );

        if (res.data.result) {
          setfeatured_product_list(res.data.data);
        }
      } catch (error) {
        console.log("Error fetching featured products", error);
      }
    };

    fetchFeaturedProducts();
  }, [_id, showmodel]); // ✅ correct dependencies

  useEffect(() => {
    const controller = new AbortController();
    const fetchFeaturedData = async () => {
      try {
        let data = {
          user_id: _id,
        };

        const res = await axios.post(
          `${process.env.REACT_APP_API}website/featured_product_list`,
          data,
          {
            headers: { token },
            signal: controller.signal,
          }
        );

        if (res?.data?.result) {
          setfeatured_product_list(res.data.data);
        }
      } catch (error) {
        if (axios.isCancel(error)) {
          console.log("Request aborted");
        } else {
          console.log(error);
        }
      }
    };
    fetchFeaturedData();
    return () => controller.abort();
  }, []);

  // Single_products handel
  let Single_products = (singleproducts) => {
    //console.log(singleproducts)
    secureLocalStorage.setItem("n_singleproducts", singleproducts);
    navigate(`/single_products`);
  };

  let loginpage = () => {
    navigate(`/login`);
  };

  // single  model  handel
  let Single_products_model = (singleproducts) => {
    console.log(singleproducts);
    // secureLocalStorage.setItem("n_singleproducts", singleproducts);
    try {
      let items = {
        product_id: singleproducts,
        user_id: _id,
      };
      axios
        .post(`${process.env.REACT_APP_API}website/product_details`, items)
        .then((res) => {
          console.log(res.data.data, "product_details");
          if (res.data.result) {
            setimages(res.data.data[0]?.product_image);
            setshowmodel(res.data.data);
          }
        })
        .catch((error) => {
          //  console.log(error)
        });
    } catch (error) {
      //console.log(error)
    }
  };

  let removelocal_showcard = () => {
    setshowmodel(null);
    secureLocalStorage.setItem("n_singleproducts", null);
  };

  // add favrate cart
  let addfevrate = (productsid) => {
    try {
      let items = {
        user_id: _id,
        product_id: productsid,
      };
      axios
        .post(
          `${process.env.REACT_APP_API}website/add_favourite_product`,
          items,
          {
            headers: {
              token: token,
            },
          }
        )
        .then((res) => {
          //  console.log(res)
          if (res.data.result) {
            toast.success(res.data.msg);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {}

    //console.log(prducts_id)
  };

  const counter_price = showmodel?.[0]?.price?.[indexvalue] * counter;
  //console.log(counter_price)

  // counter app
  let increment = () => {
    setcounter(counter + 1);
  };

  let decrement = () => {
    if (counter > 1) {
      setcounter(counter - 1);
    }
  };

  // index voice value change
  let qantity_index = (indexid) => {
    //  console.log(indexid)
    setindex_vlaue(indexid);
  };

  // post add_to_cart handel
  let add_to_cart = (cart) => {
    try {
      let data = {
        
        user_id: _id,
        product_id: cart._id,
        quantity: cart.quantity?.[0],
        no_of_product: 1,
        mrp: cart.mrp,
        price: cart.price?.[0],
        total_mrp_ammount: cart.mrp,
        total_price_ammount: cart.price?.[0],
        product_name: cart.product_name,
        product_image: cart.product_image,
      };

      //console.log(data)
      axios
        .post(`${process.env.REACT_APP_API}website/add_to_cart`, data, {
          headers: {
            token: token,
          },
        })
        .then((res) => {
          console.log(res);
          //  setsuccess_cart(res.data.data)
          setcardstatus(true);
          secureLocalStorage.setItem("n_showcart", res.data.data);
          secureLocalStorage.setItem("n_cartlist_id", res.data.data._id);
        })
        .catch((error) => {
          console.log(error);
          setcardstatus(false);
        });
    } catch (error) {
      console.log(error);
    }
  };

  // add to card model
  let add_to_cart_model = (modeldata) => {
    try {
      let data = {

        user_id: _id,
        product_id: modeldata?._id,
        quantity: modeldata?.quantity?.[indexvalue],
        no_of_product: counter,
        mrp: modeldata?.mrp,
        price: modeldata?.price?.[indexvalue],
        total_mrp_ammount: modeldata?.mrp,
        total_price_ammount: counter_price,
        product_name: modeldata?.product_name,
        product_image: modeldata?.product_image?.[0],
      };

      console.log(data);
      axios
        .post(`${process.env.REACT_APP_API}website/add_to_cart`, data, {
          headers: {
            token: token,
          },
        })
        .then((res) => {
          console.log(res.data);
          setcardstatus(true);
          //secureLocalStorage.setItem("n_showcart", res.data.data);
          secureLocalStorage.setItem("n_cartlist_id", res.data.data._id);
        })
        .catch((error) => {
          //console.log(error)
          setcardstatus(false);
        });
    } catch (error) {
      // console.log(error)
    }
    //console.log(showcartmodel, "cart model dataaaaaa")
  };

  //useState
  let [categorey, setcategorey] = useState([]);
  useEffect(() => {
    const fetchCategoryList = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API}website/category_list`);
        if (res.data.result) {
          setcategorey(res.data.data);
        }
      } catch (error) {
        console.log("Error fetching category list", error);
      }
    };

    fetchCategoryList();
  }, []);

  return (
    <>
      <ToastContainer position="top-center" />

      <section className="new-arrival-carousel-section section-mb">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12">
              <div className="row align-items-center">
                <div className="col-xl-3 col-md-4 col-12">
                  <div className="section-title">
                    <h2 className="title">Featured Products</h2>
                  </div>
                </div>
                {/* <div className="col-xl-9 col-md-8 col-12">
                  <div className="badge bg-danger">
                    <p id="demo" />
                  </div>
                </div> */}
              </div>
            </div>
          </div>
          <br />
        </div>

        <Slider {...settings}>
          {featured_product_list?.map((items) => {
            return (
              <div className="new-arrival-carousel-item swiper-slide">
                {/* product-card-list start */}
                <div
                  className="product-card-list"
                  style={{ marginRight: "-10px" }}
                >
                  {/* product-card start */}
                  <div className="product-card">
                    <span style={{backgroundColor:"#ffa11d"}} className="badge product-badge">
                      {items.offer_percent === 0
                        ? ""
                        : items.offer_percent + "%"}
                    </span>
                    <div className="product-thumb-nail">
                      <div className="text-center">
                        <img
                          className="product-image p-2 img-fluid"
                          width={"100%"}
                          src={`${process.env.REACT_APP_API}uploads/${items.product_image}`}
                          alt="image_not_found"
                        />
                      </div>
                      <ul className="actions">
                        {token ? (
                          items.favourite_status == 1 ? (
                            <li className="action whish-list">
                              {" "}
                              <BsFillSuitHeartFill
                                style={{ color: "red" }}
                                onClick={() =>
                                  addfevrate(items._id, items.favourite_status)
                                }
                              />
                            </li>
                          ) : (
                            <li
                              className="action whish-list"
                              onClick={() =>
                                addfevrate(items._id, items.favourite_status)
                              }
                            >
                              <i className="lar la-heart" />
                            </li>
                          )
                        ) : (
                          <li className="action whish-list">
                            <button
                            // data-bs-toggle="modal"
                            // data-bs-target="#product-modal-wishlist"
                            >
                              <a href="/login">
                                <i className="lar la-heart" />
                              </a>
                            </button>
                          </li>
                        )}
                        <li className="action quick-view">
                          {token ? (
                            <button data-toggle="modal" data-target="#myModal3">
                              <i
                                className="las la-eye"
                                onClick={() => Single_products_model(items._id)}
                              />
                            </button>
                          ) : (
                            <a href="/login">
                              {" "}
                              <button>
                                <i className="las la-eye" />
                              </button>
                            </a>
                          )}
                        </li>
                      </ul>
                    </div>
                    <div className="product-content">
                      <h4 className="product-sub-title">
                        <a href="#">{items.category_name}</a>
                      </h4>
                      {token ? (
                        <h3 className="product-title">
                          <a
                            onClick={() => Single_products(items._id)}
                            href="#"
                          >
                            {items.product_name}
                          </a>
                        </h3>
                      ) : (
                        <a href="/login">
                          {" "}
                          <h3
                            className="product-title"
                            onClick={() => loginpage(items._id)}
                          >
                            {items.product_name}
                          </h3>
                        </a>
                      )}

                      <div className="product-price-wrapp">
                        <span className="product-regular-price">
                          ₹{items.mrp}
                        </span>
                        <span className="product-price-on-sale">
                          ₹{items?.price?.[0]}
                        </span>
                        <span className="badge bg-success"></span>
                      </div>
                      <div className="product-cart-btn-wrap">
                        {token ? (
                          <button
                            className="btn btn-dark add-to-cart-btn"
                            data-toggle="modal"
                            data-target="#featured"
                            onClick={() => add_to_cart(items)}
                          >
                            Add to cart
                          </button>
                        ) : (
                          <button className="btn btn-dark add-to-cart-btn">
                            <Link to="/login" className="text-white">
                              Add to cart
                            </Link>
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                  {/* product-card end */}
                </div>
                {/* product-card-list end */}
              </div>
            );
          })}
        </Slider>
      </section>

      <div className="modal" id="myModal3">
        <div className="modal-dialog modal-dialog-centered product-modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                style={{ fontSize: "35px" }}
                class="close"
                data-dismiss="modal"
                onClick={removelocal_showcard}
              >
                &times;
              </button>
            </div>
            {showmodel?.length > 0 ? (
              <div className="modal-body">
                <div className="row mb-n7">
                  <div className="col-md-5 mb-7">
                    <div className="modal-gallery-slider">
                      <div className="gallery position-relative">
                        {/* <span className="badge bg-success product-badge" style={{ zIndex: "0" }}>new</span> */}
                        <div>
                          {/* <h2 style={{ textAlign: 'center' }}>Image Gallery</h2> */}
                          <div className="container">
                            <div className="mySlides">
                              <div className="numbertext">
                                {slideIndex + 1} / {images.length}
                              </div>

                              <img
                                className="img-fluid"
                                src={`${process.env.REACT_APP_API}uploads/${images[slideIndex]}`}
                                style={{ width: "100%", height: "300px" }}
                                alt={`Image ${slideIndex + 1}`}
                              />
                            </div>
                            <a
                              className="prev"
                              style={{ cursor: "pointer" }}
                              onClick={() => plusSlides(-1)}
                            >
                              ❮
                            </a>
                            <a
                              className="next"
                              style={{ float: "right", cursor: "pointer" }}
                              onClick={() => plusSlides(1)}
                            >
                              ❯
                            </a>
                            <div className="row justify-content-center">
                              {images.map((image, index) => (
                                <img
                                  className={`img-fluid shadow m-1 demo cursor${
                                    index === slideIndex ? " active" : ""
                                  }`}
                                  src={`${process.env.REACT_APP_API}uploads/${image}`}
                                  style={{ width: "20%", height: "80px" }}
                                  onClick={() => currentSlide(index)}
                                  alt={`Image ${index + 1}`}
                                />
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-7 mb-7">
                    <div
                      className="modal-product-des"
                      style={{ marginTop: "25px" }}
                    >
                      <h3 className="modal-product-title">
                        {showmodel?.[0]?.product_name}
                      </h3>
                      <h3 className="modal-product-sub-title">
                        Category: {showmodel?.[0]?.category_name}
                      </h3>
                      <div className="reviews">
                        <span className="las la-star" />
                        <span className="las la-star" />
                        <span className="las la-star" />
                        <span className="las la-star" />
                        <span className="las la-star" />
                      </div>

                      <div className="pt-1">
                        <span className="" style={{ fontSize: "20px" }}>
                          {" "}
                          Offer
                        </span>
                        <span className="badge badge-lg bg-dark">
                          {showmodel?.[0]?.offer_percent}%
                        </span>
                      </div>

                      <div className="product-price-wrapp-lg">
                        <span className="product-price-on-sale-lg">
                          ₹{counter_price}
                        </span>
                        <span className="product-regular-price-lg pl-2">
                          ₹{showmodel?.[0]?.mrp}
                        </span>
                        {/* <span className="badge badge-lg bg-dark">Save 8%</span> */}
                      </div>
                      <div className="product-description-short pb-7 mb-7">
                        <ul>
                          <li>{showmodel?.[0]?.description}</li>
                        </ul>

                        {showmodel?.[0]?.quantity?.map((items, index) => {
                          return (
                            <button
                              className="btn btn-success m-1"
                              onClick={() => qantity_index(index)}
                            >
                              {items}
                            </button>
                          );
                        })}

                        {/* 
    {data?.map((items) => {
      return (
        <button className='btn btn-success m-1'>
          {items.quantity}
        </button>
      )
    })} */}
                      </div>

                      <div className="product-add-to-cart">
                        <span className="control-label">Quantity</span>
                        <div className="product-count style d-flex my-7">
                          <div className="count d-flex">
                            <input
                              disabled
                              type="number"
                              min={1}
                              max={100}
                              Value={counter}
                            />
                            <div className="button-group">
                              <button className="count-btn increment">
                                <span
                                  className="las la-angle-up"
                                  onClick={increment}
                                />
                              </button>
                              <button className="count-btn decrement">
                                <span
                                  className="las la-angle-down"
                                  onClick={decrement}
                                />
                              </button>
                            </div>
                          </div>
                          <div>
                            {token ? (
                              <button
                                data-toggle="modal"
                                data-target="#featured"
                                onClick={() =>
                                  add_to_cart_model(showmodel?.[0])
                                }
                                data-bs-target="#addto-cart-modal"
                                className="modal-add-to-cart-btn"
                              >
                                Add to cart
                              </button>
                            ) : (
                              <button className="modal-add-to-cart-btn">
                                <Link to="/login" className="text-white">
                                  Add to cart
                                </Link>
                              </button>
                            )}
                          </div>
                        </div>
                        <div className="product-add-to-card">
                          {token ? (
                            showmodel[0]?.favourite_status == 1 ? (
                              <li
                                className="action whish-list"
                                style={{ cursor: "pointer" }}
                              >
                                {" "}
                                <BsFillSuitHeartFill
                                  style={{ color: "red", cursor: "pointer" }}
                                  onClick={() =>
                                    addfevrate(
                                      showmodel[0]?.product_details,
                                      showmodel[0].favourite_status
                                    )
                                  }
                                />
                              </li>
                            ) : (
                              <li
                                className="action whish-list"
                                style={{ cursor: "pointer" }}
                                onClick={() =>
                                  addfevrate(
                                    showmodel[0]?._id,
                                    showmodel[0]?.favourite_status
                                  )
                                }
                              >
                                <i className="lar la-heart" />
                              </li>
                            )
                          ) : (
                            <li className="action whish-list">
                              <button
                              // data-bs-toggle="modal"
                              // data-bs-target="#product-modal-wishlist"
                              >
                                <Link to="/login">
                                  <i className="lar la-heart" />
                                </Link>
                              </button>
                            </li>
                          )}
                        </div>
                        <div className="product-social-sharing mt-7">
                          <span>Share</span>
                          <ul>
                            <li className="facebook">
                              <a href="#" target="_blank">
                                <i className="lab la-facebook-f" />
                              </a>
                            </li>
                            <li className="twitter">
                              <a href="#" target="_blank">
                                <i className="lab la-twitter" />
                              </a>
                            </li>
                            <li className="pinterest">
                              <a href="#" target="_blank">
                                <i className="lab la-pinterest" />
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <>
                {" "}
                <div className="row justify-content-center pb-5">
                  <div class="loader"></div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      <div className="modal fade" id="featured">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header bg-dark border-bottom-0 justify-content-center">
              {/* <span className="ion-android-done me-5" /> */}
              <h4 className="modal-title text-center text-white">
                {cardstatus == true
                  ? "Product successfully added to your shopping cart"
                  : "All redy added to your shopping cart"}{" "}
              </h4>
              {/* <button type="button" className="btn-close position-absolute" data-bs-dismiss="modal" aria-label="Close">×</button> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Featuredproducts;
